import React from 'react';
import { FaBuilding, FaRocket, FaSearch, FaCogs } from 'react-icons/fa';

const Servicos = () => {
  const servicos = [
    {
      icon: <FaBuilding className="text-4xl" />,
      title: 'Sites Institucionais',
      description: 'Fachadas digitais à altura da sua autoridade. Para clínicas, escritórios, consultorias e empreendedores que querem presença profissional.',
      destaque: true,
    },
    {
      icon: <FaRocket className="text-4xl" />,
      title: 'Landing Pages de Alta Conversão',
      description: 'Páginas focadas em ROI para infoprodutores e prestadores de serviços. Velocidade, clareza e resultados que aparecem.',
      destaque: true,
    },
    {
      icon: <FaSearch className="text-4xl" />,
      title: 'SEO & Posicionamento',
      description: 'A autoridade que você já construiu refletida com clareza no Google. Estratégia para quem quer ser encontrado.',
      destaque: true,
    },
    {
      icon: <FaCogs className="text-4xl" />,
      title: 'Sistemas Personalizados',
      description: 'Soluções que automatizam e profissionalizam a operação do seu negócio. Complemento ideal para quem precisa ir além do site.',
      destaque: false,
    },
  ];

  return (
    <section id="servicos" className="py-32 bg-cream dark:bg-dark-bg transition-colors duration-500">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 gsap-reveal">
          <p className="text-burnt font-heading font-semibold uppercase tracking-wider text-sm mb-4">
            Serviços
          </p>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-dark dark:text-cream mb-4">
            Criação de sites que geram resultados
          </h2>
          <p className="text-xl text-dark/70 dark:text-cream/70 max-w-2xl mx-auto font-body">
            Especialista em sites institucionais modernos e personalizados.
            Também desenvolvo sistemas sob medida quando seu negócio precisa de mais.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {servicos.map((servico, index) => (
            <div
              key={index}
              className={`gsap-reveal group p-8 rounded-2xl transition-all duration-500 transform hover:-translate-y-2 hover:shadow-premium dark:hover:shadow-premium-dark border ${
                servico.destaque
                  ? 'bg-white dark:bg-dark-surface border-burnt/20 dark:border-burnt/30 hover:border-burnt/50'
                  : 'bg-white/50 dark:bg-dark-surface/50 border-brown/10 dark:border-burnt/10 opacity-90'
              }`}
            >
              <div className="flex items-start gap-4">
                <div className="text-burnt group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                  {servico.icon}
                </div>
                <div>
                  <div className="flex items-center gap-2 mb-3">
                    <h3 className="text-xl font-heading font-semibold text-dark dark:text-cream">
                      {servico.title}
                    </h3>
                    {servico.destaque && (
                      <span className="px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider bg-burnt/10 text-burnt rounded-full">
                        Principal
                      </span>
                    )}
                  </div>
                  <p className="text-dark/70 dark:text-cream/70 leading-relaxed font-body">
                    {servico.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Servicos;
